import React from 'react'
import { useTranslation } from 'react-i18next'

import { SubscriptionDetailsTab } from 'root-constants'

import { StyledDetailsTab as S } from './DetailsTab.styles'

type TProps = {
  activeTab: SubscriptionDetailsTab
  handleChange: (event: SubscriptionDetailsTab) => void
}

export const DetailsTab: React.FC<TProps> = ({ activeTab, handleChange }) => {
  const { t } = useTranslation()

  return (
    <S.TabsContainer>
      <S.Tab
        isActive={SubscriptionDetailsTab.ACCOUNT === activeTab}
        onClick={() => handleChange(SubscriptionDetailsTab.ACCOUNT)}
      >
        {t('subscription.tabs.account')}
      </S.Tab>
      <S.Tab
        isActive={SubscriptionDetailsTab.SUBSCRIPTIONS === activeTab}
        onClick={() => handleChange(SubscriptionDetailsTab.SUBSCRIPTIONS)}
      >
        {t('subscription.tabs.subscriptions')}
      </S.Tab>
    </S.TabsContainer>
  )
}
